<template>
  <div>
    <v-row v-if="avaliacoes.length > 0">
      <v-col>
        <app-title texto="GESTORES SEM RESPONSABILIDADES" />
        <v-data-table
          :headers="headers"
          :items="avaliacoes"
          :items-per-page="-1"
          hide-default-footer
          hide-default-header
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';

export default {
  name: 'AvaliacaoGestoresSemResponsabilidades',

  components: { AppTitle },

  props: {
    avaliacoes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: 'AVALIADO', value: 'avaliado.nome', sortable: false },
        { text: 'UNIDADE', value: 'avaliado.unidadeVersao.sigla', sortable: false },
      ],
    };
  },
};
</script>
